var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg272697ExcelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m28.705 7.506-5.461-6.333-1.08-1.254H9.262a3.133 3.133 0 0 0-3.133 3.136V7.04h1.942L8.07 3.818a1.761 1.761 0 0 1 1.758-1.764l11.034-.01v5.228a3.522 3.522 0 0 0 3.524 3.523h3.819l-.188 15.081a1.77 1.77 0 0 1-1.759 1.761l-16.57-.008c-.887 0-1.601-.87-1.605-1.942V24.41H6.138v1.904c0 1.912 1.282 3.468 2.856 3.468l17.831-.004a3.141 3.141 0 0 0 3.137-3.139V8.966l-1.257-1.46",
    fill: "#ffffff",
    fillRule: "evenodd",
    className: "fill-434440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.223 25.382H0V6.068h20.223v19.314m-18.28-1.944h16.333V8.012H1.943",
    fill: "#cfcfcf",
    className: "fill-08743b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfcfcf",
    d: "M15.73 20.822h-3.405l-2.324-3.284-2.44 3.284H4.14l4.244-5.336-3.427-4.669h3.455l1.604 2.538 1.71-2.538h3.516l-3.593 4.669 4.081 5.336",
    className: "fill-08743b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg272697ExcelIcon);
export default __webpack_public_path__ + "static/media/272697_excel_icon.c58242ad3aad5fe1fa8ab89bb99b0177.svg";
export { ForwardRef as ReactComponent };